import { NgFor, NgIf } from '@angular/common';
import { ChangeDetectorRef, Component, inject } from '@angular/core';
import { RouterLink, RouterLinkActive } from '@angular/router';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { LocalizationDictionary, LocalizationService } from '../../../../_jovdk-web/features/localization-service/localization-service.service';
import { ExternalUrlResolverService } from '../../../../_jovdk-web/features/url-resolver/external-url-resolver.service';

interface NavLink {
    labelKey: string;
    path?: string;
    externalUrl?: string;
    resolvedExternalUrl?: string;
}

@Component({
    selector: 'app-nav-bar',
    standalone: true,
    imports: [
        NgIf,
        NgFor,
        RouterLink,
        RouterLinkActive,
    ],
    templateUrl: './nav-bar.component.html',
    styleUrl: './nav-bar.component.css'
})
export class NavBarComponent
{
    protected readonly _localizationService = inject(LocalizationService);
    private _externalUrlResolver = inject(ExternalUrlResolverService);
    private _cdr = inject(ChangeDetectorRef);

    _navLinks: NavLink[];
    terms: LocalizationDictionary = {};
    currentLanguageShortCode = '';

    _isSelectingLanguage = false;
    _isMenuOpen = false;

    constructor()
    {
        this._navLinks = this.BuildNavLinks();
        this._localizationService.Terms$
            .pipe(takeUntilDestroyed())
            .subscribe((dictionary) =>
            {
                this.terms = dictionary;
                this.currentLanguageShortCode = this._localizationService._currentLanguageOption?.ShortCode ?? '';
                this._cdr.markForCheck();
            });
    }

    private BuildNavLinks = (): NavLink[] =>
    {
        return [
            { labelKey: 'nav-home', path: '/' },
            { labelKey: 'nav-downloads', path: '/downloads' },
            { labelKey: 'nav-nodes', path: '/nodes' },
            { labelKey: 'nav-requirements', path: '/requirements' },
            { labelKey: 'nav-docs', path: '/docs' },
            {
                labelKey: 'nav-scan',
                externalUrl: 'https://scan.hbariot.com',
                resolvedExternalUrl: this._externalUrlResolver.Resolve('https://scan.hbariot.com'),
            },
        ];
    };

    ToggleMenu = () =>
    {
        this._isMenuOpen = !this._isMenuOpen;
    };

    CloseMenu = () =>
    {
        this._isMenuOpen = false;
    };

    ToggleLanguageSelection = () =>
    {
        this._isSelectingLanguage = !this._isSelectingLanguage;
    };

    LanguageOptionButton = (languageId: string) =>
    {
        this._isSelectingLanguage = false;
        this._localizationService.SetCurrentLanguage(languageId);
    };

    TrackByLabel = (_index: number, link: NavLink) => link.labelKey;
}
